import { render, staticRenderFns } from "./sttsdealerlogs.vue?vue&type=template&id=f326f04c&scoped=true"
import script from "./sttsdealerlogs.vue?vue&type=script&lang=js"
export * from "./sttsdealerlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f326f04c",
  null
  
)

export default component.exports